export class NeoUsuarioIntermediario {
  constructor(
    public areaCompania: String,
    public cargo: String,
    public celular: String,
    public correoElectronico: String,
    public direccion: String,
    public extension: String,
    public idCiudad: Number,
    public idDepartamento: Number,
    public idUsuarioRegistro: Number,
    public identificador: String,
    public numeroDocumento: String,
    public primerApellido: String,
    public primerNombre: String,
    public segundoApellido: String,
    public segundoNombre: String,
    public telefonoFijo: String,
    public idCliente_NeoCliente: Number,
    public idTipoDocIdentidad_NeoTipoDocIdentidad: Number,
    public sucursalOficina:String,
    public ventaIncialAtendido: Number,
    public ventaFinalAtendido: Number,
    public departamentosSeleccionados: [],
    public aplicaTodosDepartamentos: boolean
  ) {}
}
